export const notoFont = ['Noto Sans JP', 'Noto', 'Lato', 'Roboto', 'sans-serif'].join(
  ',',
);
